import { z } from "zod";
import { SlideElementSchema } from "./draggables";

export const SlideStyleTypeEnum = z.enum(["default", "personal"]);

export const SlideStyleSchema = z.object({
  id: z.string(),
  name: z.string(),
  elements: z.array(SlideElementSchema),
  imageId: z.string(),
  type: SlideStyleTypeEnum,
});

export type SlideStyleType = z.infer<typeof SlideStyleTypeEnum>;
export type SlideStyle = z.infer<typeof SlideStyleSchema>;
